import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
   <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 0 127 55"
    style={{
      enableBackground: "new 0 0 127 55",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        `\n\t.sr_st0{fill:none;stroke:${strokeColor};stroke-width:0.6;stroke-miterlimit:10;}\n`
      }
    </style>
    <g id="Layer_2_00000078034766437017628660000014651781136001089711_">
      <g id="Layer_4_00000012445408901645575590000007929448687252741774_">
        <g>
          <path className="sr_st0" d="M116.2,41.8" />
          <path
            className="sr_st0"
            d="M124.7,25.7L124.7,25.7L124.7,25.7L124.7,25.7z"
          />
          <path
            className="sr_st0"
            d="M93.7,45.1c0-0.6,0.1-2.1,0.1-3c0-0.1,0-0.2,0-0.6c0-0.5,0.3-2.1,0.3-2.1c0.6-2.8,2.3-6.7,6.1-7.9 c3.7-1.5,7.7-1.1,10.7,0.6l0.3,0.1c1.8,1,2.9,2.6,3.8,4.6c0,0,0.6,1.8,0.9,4.1c0,0.1,0,0.4,0,0.4c0,0.1,0,0.2,0,0.4"
          />
          <path
            className="sr_st0"
            d="M34.9,40.1c1.1,0.4,1.3,2.7,1.3,2.9c0,0.1,0.1,0.8,0.1,0.8l0.2,0.3l55.9,0.6h1.5h-0.2l0,0"
          />
          <path
            className="sr_st0"
            d="M2.6,23.6c-0.1,0.2-0.5,1.3-0.7,1.8c-0.1,0.2-0.1,3.1-0.1,3.4c0.1,1.6,0.1,2.4,0.1,3.3c0,0,0.1,0.9,0,1 c-0.1,0.5-0.2,2.4-0.2,2.4s0,0.6,0,0.9c0,0,0,0.4,0,0.5c0,0-0.2,0.2-0.2,0.4v0.1c0,0.1,0.8,0.9,0.8,0.9c0.1,0,0,0.3-0.2,0.5 c0,0-0.4,0.4-0.4,0.5c-0.1,0.2-0.3,0.6-0.2,0.8c0,0,0.2,0.3,0.2,0.5c0,0.1,0,0.1,0,0c0,0.1,0.1,0.8,0.2,0.9l0.6,0.3l4.1,0.6 c0.1,0,2.9,0.3,2.9,0.3l3.5,0.4l0.6-1"
          />
          <path
            className="sr_st0"
            d="M115.9,41.7c0,0.2,0.1,2.6,0,2.8c0,0,0.1,0,0.2,0c0.2,0,0.9-0.1,0.9-0.1c0.2,0,4.9-0.3,5.2-0.4l1.6,0.5 l0.6-1.1c0.5-0.1,1.1-0.2,1.1-0.2l0.3-0.2l0.2-0.4l0.1-0.2c0.2-0.5,0.4-1,0.4-1.2c0-0.4-1.7-2.3-1.7-2.6c0,0,0.5-3,0.6-3.5 c0,0-0.2-3.6-0.4-6.1c-0.1-1.4-0.5-2.3-1.7-3l-2.2-1.1"
          />
        </g>
      </g>
      <path className="sr_st0" d="M35.1,40.3c0-12.8-22-14.8-21.5,2" />
      <g id="Layer_2_00000155121443628905800900000004859472908403130512_">
        <ellipse className="sr_st0" cx={24.2} cy={41.4} rx={9.5} ry={9.8} />
        <path
          className="sr_st0"
          d="M16.9,41.4c0,4.1,3.3,7.1,7.1,7.1s7.1-3.3,7.1-7.1s-3.3-7.1-7.1-7.1C20.2,34.1,16.9,37.6,16.9,41.4z"
        />
        <path
          className="sr_st0"
          d="M17.1,41.7c1-0.1,2-0.2,3-0.2c0.9-0.1,1-1.4,0.2-2c-0.7-0.6-1.4-1-2.1-1.5l-0.1-0.2c0.1-0.2,0.7-1.3,1.3-1.4 c0.1,0,0.2,0,0.2,0c0.7,0.7,1.3,1.3,1.9,1.9c0.7,0.7,1.9,0.1,1.9-0.7c-0.1-1-0.1-2.1-0.2-3.1c0.2-0.2,2-0.2,2.1,0 c-0.1,1-0.1,2.1-0.2,3.1s1.2,1.4,1.9,0.7c0.8-0.8,1.3-1.3,1.9-1.9l1.2,1.5c0,0.1,0,0.1,0,0.2c-0.6,0.5-1,0.9-1.7,1.3 c-0.7,0.6-0.6,1.9,0.2,2c1,0.1,1.3,0.1,2.4,0.2l-0.3,2.1c0.1,0.1-1.2,0-2.2-0.4c-0.7-0.2-1.5,0.7-1.3,1.4c0.5,0.9,0.6,1.3,1.2,2.1 c0,0-1.2,1-1.4,1c-0.1,0-0.2,0-0.2-0.1c-0.2-0.9-0.6-1.5-0.9-2.7c-0.2-0.9-1.6-0.9-2.1,0c-0.3,0.9-0.6,1.5-0.9,2.6 c0,0-0.1,0.5-0.2,0.5c-0.2,0-1.7-0.4-1.9-0.7c-0.1-0.1,0.3-0.7,0.3-0.7c0.5-0.9,0.7-1.4,1.3-2.2c0.2-0.7-0.2-1.5-1.3-1.4 c-0.9,0.2-2.7,0.5-3.7,0.7C17.3,43.6,16.9,42.2,17.1,41.7z"
        />
        <path
          className="sr_st0"
          d="M23,41.3c0,0.6,0.5,1,1,1s1-0.5,1-1s-0.5-1-1-1C23.4,40.2,23,40.7,23,41.3z"
        />
        <circle className="sr_st0" cx={21.8} cy={41.5} r={0.5} />
        <circle className="sr_st0" cx={25.8} cy={40.1} r={0.5} />
        <circle className="sr_st0" cx={23.6} cy={43.4} r={0.5} />
        <circle className="sr_st0" cx={23.5} cy={39.2} r={0.5} />
        <circle className="sr_st0" cx={26} cy={42.3} r={0.5} />
      </g>
      <g id="Layer_2_00000016073657216702278980000013240535702283208866_">
        <ellipse className="sr_st0" cx={104.7} cy={41.7} rx={9.5} ry={9.8} />
        <path
          className="sr_st0"
          d="M97.4,41.7c0,4.1,3.3,7.1,7.1,7.1c3.8,0,7.1-3.3,7.1-7.1s-3.3-7.1-7.1-7.1C100.7,34.4,97.4,37.9,97.4,41.7z"
        />
        <path
          className="sr_st0"
          d="M97.6,42c1-0.1,2-0.2,3-0.2c0.9-0.1,1-1.4,0.2-2c-0.7-0.6-1.4-1-2.1-1.5l-0.1-0.2c0.1-0.2,0.7-1.3,1.3-1.4 c0.1,0,0.2,0,0.2,0c0.7,0.7,1.3,1.3,1.9,1.9c0.7,0.7,1.9,0.1,1.9-0.7c-0.1-1-0.1-2.1-0.2-3.1c0.2-0.2,2-0.2,2.1,0 c-0.1,1-0.1,2.1-0.2,3.1c-0.1,1,1.2,1.4,1.9,0.7c0.8-0.8,1.3-1.3,1.9-1.9l1.2,1.5c0,0.1,0,0.1,0,0.2c-0.6,0.5-1,0.9-1.7,1.3 c-0.7,0.6-0.6,1.9,0.2,2c1,0.1,1.3,0.1,2.4,0.2l-0.3,2.1c0.1,0.1-1.2,0-2.2-0.4c-0.7-0.2-1.5,0.7-1.3,1.4c0.5,0.9,0.6,1.3,1.2,2.1 c0,0-1.2,1-1.4,1c-0.1,0-0.2,0-0.2-0.1c-0.2-0.9-0.6-1.5-0.9-2.7c-0.2-0.9-1.6-0.9-2.1,0c-0.3,0.9-0.6,1.5-0.9,2.6 c0,0-0.1,0.5-0.2,0.5c-0.2,0-1.7-0.4-1.9-0.7c-0.1-0.1,0.3-0.7,0.3-0.7c0.5-0.9,0.7-1.4,1.3-2.2c0.2-0.7-0.2-1.5-1.3-1.4 c-0.9,0.2-2.7,0.5-3.7,0.7C97.8,43.9,97.4,42.5,97.6,42z"
        />
        <path
          className="sr_st0"
          d="M103.5,41.6c0,0.6,0.5,1,1,1s1-0.5,1-1s-0.5-1-1-1C103.9,40.5,103.5,41,103.5,41.6z"
        />
        <circle className="sr_st0" cx={102.3} cy={41.8} r={0.5} />
        <circle className="sr_st0" cx={106.3} cy={40.4} r={0.5} />
        <circle className="sr_st0" cx={104.1} cy={43.7} r={0.5} />
        <circle className="sr_st0" cx={104} cy={39.5} r={0.5} />
        <circle className="sr_st0" cx={106.5} cy={42.6} r={0.5} />
      </g>
      <path className="sr_st0" d="M118.1,25.4c-0.4,3.4,5.5,6.5,7.3,6.5" />
      <path className="sr_st0" d="M121.6,25.1c-0.9-0.3-3.2-1.2-3.5,0.4" />
      <path className="sr_st0" d="M2.2,23.6c9.8,1.7,4.3,5.5,2.8,6.6" />
      <path className="sr_st0" d="M100.6,27.5c-6,0.3-10.8,9.1-9.6,17.3" />
      <path className="sr_st0" d="M26.3,27c8.4-0.4,13.8,8.6,11.9,17.3" />
      <path className="sr_st0" d="M2,30.6c0,0.1,1.8,0.3,3.1-0.5" />
    </g>
    <g id="Layer_4">
      <path
        className="sr_st0"
        d="M87.3,20.4h-1.5c-0.4,0-0.7-0.9-0.7-1.9l0,0c0-1.4,0.4-2.6,1-2.6h1.3c0.1,0,0.2,0.1,0.2,0.3l0.1,0.6 c0.2,0.9,0.2,2.1,0,2.9L87.6,20C87.5,20.3,87.4,20.4,87.3,20.4z"
      />
      <path className="sr_st0" d="M87,20.3" />
      <path className="sr_st0" d="M84.1,20.3" />
      <path
        className="sr_st0"
        d="M85.8,20.5l-0.1,1.1c-0.1,0.1-0.2,0.4-0.2,0.6l0.1,0.5c0.1,0.2,0.2,0.4,0.4,0.4l0.5,0.1c0.2,0.1,0.4,0,0.6-0.1 l0.4-0.4c0.1-0.1,0.2-0.4,0.2-0.6l-0.1-0.5c-0.1-0.2-0.2-0.4-0.4-0.4v-0.7C87,20.4,86.2,20.4,85.8,20.5z"
      />
    </g>
  </svg>
);
export default SvgComponent;